module.exports = __webpack_public_path__ + "img/municipalitylogo.3e7fbf3c.png";